module.exports = __webpack_public_path__ + "img/deeplink_step2.7e96a8d4.svg";